import React from "react";
import PATH from "constants/path";
import { ButtonBanner, ChevronRight } from "assets/svg";
import { isAuthenticated } from "utils/common";
import {
  illust02,
  illust06,
  illust05,
  illust21,
  illust22,
  illust23,
  illust07,
} from "assets/img";

function Guide() {
  return (
    <div className={isAuthenticated() ? "w-80" : "clap container px-0"}>
      <div className="bg-yellow py-2 text-center position-relative sp-1 fw-600 z-index-2">
        <div className="fs-12 lh-21">＼とってもカンタン!／</div>
        <div className="fs-20 fs-sm-18">ご利用方法</div>
        <img
          className="position-absolute top-100 top-sm-75 end-0 translate-middle-y img-w"
          src={illust02}
          alt={illust02}
        ></img>
      </div>

      {!isAuthenticated() ? (
        <div className="px-3 px-md-5 py-3 text-lg-center bg-brown z-index-1">
          <div className="text-grey text-center fw-600 sp-14">
            まずは、カンタン無料会員登録!
          </div>
          <div className="text-center mt-1">
            <a href={PATH.COMMON + PATH.SIGNUP}>
              <ButtonBanner className="svg-button" />
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className={`z-index-1 ${isAuthenticated() ? "mt-4" : "my-2"} `}>
        {!isAuthenticated() && (
          <div className="fs-14 fw-600 sp-14 text-center text-grey-2 mb-2 mb-md-4">
            以下、ご登録後の流れになります。
          </div>
        )}
        <div className="list-guide mx-0 mx-md-4 mx-lg-0">
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>1</span>
                <div>新しい案件に応募</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust06}
                    alt="illust06"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  ご応募いただける案件は、ログイン後にある「
                  <span className="fw-600 text-red-light">
                    募集中の番組一覧
                  </span>
                  」に掲載されております。またはご登録いただいているメールアドレス宛に直接ご案内が届くので、指定ドメインの迷惑メールの解除をお願いします。観覧参加条件をご確認いただき、画面の説明にしたがってご応募ください。ログインしていない状態では案件の詳細が表示されないのでご注意ください。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>2</span>
                <div>
                  <div>「応募中案件」で案件のステップを確認</div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust05}
                    alt="illust05"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  応募したすべての案件は「
                  <span className="fw-600 text-red-light">応募中案件</span>
                  」に表示されます。「
                  <span className="fw-600 text-red-light">ステップ詳細</span>
                  」をクリックすると、現在の進行状況をご確認できます。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>3</span>
                <div>オペレーターよりご連絡</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust21}
                    alt="illust21"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  ご当選者には、オペレーターより直接お電話にて「
                  <span className="fw-600 text-red-light">本人確認</span>
                  」の連絡を差し上げます。ご参加日の前日までに連絡がなかった場合は、落選とさせていただきます。
                  <br />
                  なお、本人確認以降のキャンセルは基本的に受け付けておりませんので、あらかじめご了承ください。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>4</span>
                <div>最終確認</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust22}
                    alt="illust2"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  参加日の前日までに「
                  <span className="fw-600 text-red-light">最終確認メール</span>
                  」をお送りします。事前に必ず内容をご確認いただき、メールに記載されているURLの「
                  <span className="fw-600 text-red-light">確認フォーム</span>
                  」にご回答ください。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <h5 className="title">
                <span>5</span>
                <div>参加当日</div>
              </h5>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust23}
                    alt="illust23"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  参加当日に現場で出欠確認を行います。あらかじめ交通状況をご確認のうえ、時間には余裕をもってご参加ください。万が一、体調不良や事故などやむを得ない事情で遅刻、欠席される場合は、「最終確認メール」に記載されている緊急連絡先までご連絡ください。
                </div>
              </div>
            </div>
          </div>

          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <h5 className="title">
                <span>6</span>
                <div>謝礼を受け取る</div>
              </h5>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0">
                  <img
                    src={illust07}
                    alt="illust07"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-2 mt-2">
                  案件参加終了の確認できましたら、謝礼のポイントが付与されます。
                  <br />
                  <span className="fw-600 text-red-light">
                    3,000ポイント以上
                  </span>
                  貯めると、お振込みの対象となります。 <br />
                  案件参加終了からポイント付与まで
                  <span className="fw-600 text-red-light">最大2か月</span>
                  かかることもありますのであらかじめご了承ください。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fw-400 fs-14 sp-14 my-3 my-md-5">
        <div className="bg-brown py-1">
          <div className="text-grey fs-18 fw-600 text-center">注意事項</div>
        </div>
        <div className="px-3 px-lg-0">
          <div className="my-3">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              案件の参加条件は必ずお守りください。
            </div>
            <div>
              CLAP&WALKで掲載している案件には、年齢や性別など、いくつか参加条件を設けている場合があります。参加条件に当てはまらない案件にご応募いただいたり、参加条件を偽ってご応募いただいた場合には、謝礼ポイントの付与はされません。悪質な場合は、退会処分となります。
            </div>
          </div>
          <div className="my-3">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              機密保持にご協力ください。
            </div>
            <div>
              CLAP&WALKで掲載している案件の内容や参加をして知り得た一切の情報をSNS、YouTube、ブログ、ネット掲示板などに書き込み、転載、転記することは固く禁じております。また、現場で写真撮影する行為も同様に固く禁じております。
            </div>
          </div>
          <div className="my-3">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              お振込をお断りするケース
            </div>
            <div>
              CLAP&WALKでは、以下の事由に当てはまる場合は、案件参加後であってもポイントの付与をお断りすることがあります。{" "}
              <br /> <br />
              ・氏名、年齢、性別など個人情報を偽って登録した場合 <br />
              ・参加条件を偽ってご応募した場合 <br />
              ・案件の掲載期限を超えて完了した場合 <br />
              ・機密保持などの注意事項を破った場合
            </div>
          </div>
          <div className="my-4">
            <span className="me-1 text-red-light">
              <i className="bi bi-exclamation-triangle-fill"> </i>
            </span>
            上記注意事項を破られた場合は、ポイントの付与がされないだけでなく、損害賠償請求をさせていただきますのでくれぐれもご注意ください。
          </div>
        </div>
      </div>

      <div className="text-grey fw-600 my-4">
        <div className="w-130 mx-auto cursor-pointer text-end mt-3 mt-md-2">
          <a href={PATH.FIRST}>
            はじめての方へ
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="w-130 mx-auto cursor-pointer text-end mt-3 mt-md-2">
          <a href={PATH.POINT}>
            ポイントについて
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="w-130 mx-auto cursor-pointer text-end mt-3 mt-md-2">
          <a href={PATH.QUESTIONS}>
            よくあるご質問
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Guide;
